var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"msp-andature-dettaglio",class:_vm.classComponent,domProps:{"innerHTML":_vm._s(_vm.renderDescrizione(_vm.dettaglio, _vm.sport_id, {format: 'html', valoriZona: _vm.valoriZona}))}})
}
var staticRenderFns = []

export { render, staticRenderFns }